import { mergeMap, catchError, map } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ofType } from 'redux-observable';
import i18next from 'i18next';
import { getCluster, getClusters } from 'gql/KubernetesCluster';
import RootEpic from 'store/RootEpic';
import KubernetesClusterSlice from 'components/pages/console/store/KubernetesClusterSlice';
import { showNotificationFromError } from 'components/app/store/UserSlice';

export const fetchClusterEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(KubernetesClusterSlice.actions.fetchCluster),
    mergeMap(({ payload }) =>
      from(getCluster(payload)).pipe(
        map((response) => KubernetesClusterSlice.actions.fetchClusterSucceeded(response)),
        catchError((error) => of(KubernetesClusterSlice.actions.fetchClusterFailed(error)))
      )
    )
  );

export const fetchClusterFailedEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(KubernetesClusterSlice.actions.fetchClusterFailed),
    map(({ payload }) => showNotificationFromError({ msg: i18next.t('FAILED_GET_CLUSTER'), err: payload }))
  );

export const fetchClustersEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(KubernetesClusterSlice.actions.fetchClusters),
    mergeMap(({ payload }) =>
      from(getClusters(payload)).pipe(
        map((response) => KubernetesClusterSlice.actions.fetchClustersSucceeded(response)),
        catchError((error) => of(KubernetesClusterSlice.actions.fetchClustersFailed(error)))
      )
    )
  );

export const fetchClustersFailedEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(KubernetesClusterSlice.actions.fetchClustersFailed),
    map(({ payload }) => showNotificationFromError({ msg: i18next.t('FAILED_GET_CLUSTERS'), err: payload }))
  );

const KubernetesClusterEpics: RootEpic[] = [
  fetchClusterEpic,
  fetchClusterFailedEpic,
  fetchClustersEpic,
  fetchClustersFailedEpic,
];

export default KubernetesClusterEpics;
